import { atom } from "recoil";

export const likeState = atom({
  key: "likeState",
  default: [0, 0, 0],
});

export const likeImgState = atom({
  key: "likeImgState",
  default: [true, true, true],
});

export const totalLikeState = atom({
  key: "totalLike",
  default: 0,
});

export const loadingBarState = atom({
  key: "loadingBarState",
  default: false,
});
